import { Translator } from 'Translator';
import classnames from 'classnames';
import Input from 'modules/authentication/components/common/Input';
import VisibilityIcon from 'modules/authentication/components/common/VisibilityIcon';
import React, { Component } from 'react';

const CSS = require('./PasswordInput.module.scss');

interface PasswordInputProps {
  handleChange: (e: any) => void;
  className?: string;
  autoComplete?: string;
  error?: string;
  value?: string;
  name?: string;
  showAsteriks?: boolean;
  'data-test-id'?: string;
  placeholder?: string;
  alwaysShowLabel?: boolean;
}

interface PasswordInputState {
  passwordVisible: boolean;
}

class PasswordInput extends Component<PasswordInputProps, PasswordInputState> {
  state = {
    passwordVisible: false,
  };

  togglePasswordVisibility = () => {
    this.setState({
      passwordVisible: !this.state.passwordVisible,
    });
  };

  render() {
    const {
      autoComplete,
      handleChange,
      showAsteriks,
      placeholder,
      alwaysShowLabel,
      'data-test-id': dataTestId,
    } = this.props;

    let label =
      placeholder ||
      Translator.translate('Forms.Labels.password', {}, true, 'Password');
    if (showAsteriks) {
      label += ' *';
    }

    return (
      <div className={classnames(this.props.className, CSS.PasswordInput)}>
        <Input
          data-test-id={dataTestId}
          placeholder={label}
          labelName={label}
          autoComplete={autoComplete}
          className={CSS.input}
          type={this.state.passwordVisible ? 'text' : 'password'}
          value={
            typeof this.props.value === 'string' ? this.props.value : undefined
          }
          name={this.props.name || 'password'}
          onChange={handleChange}
          required={true}
          error={this.props.error}
          alwaysShowLabel={alwaysShowLabel}
        />
        <button
          tabIndex={-1}
          type={'button'}
          className={CSS.Toggle}
          onClick={this.togglePasswordVisibility}
        >
          <VisibilityIcon
            visibility={this.state.passwordVisible ? 'on' : 'off'}
          />
        </button>
      </div>
    );
  }
}

export default PasswordInput;
